import { render, staticRenderFns } from "./GradientBG.vue?vue&type=template&id=16fa8895&"
import script from "./GradientBG.vue?vue&type=script&lang=js&"
export * from "./GradientBG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports